module.exports = __webpack_public_path__ + "assets/img/组 156@2x.3c32644b.jpg";